<template>
  <a @click="routerPage(task)" class="content-card-tasks">
    <div class="content-card-tasks--description">
      <h2>{{ task.name }}</h2>
      <p>{{ task.description }}</p>
    </div>
    <!-- <div class="content-card-tasks--details">
      <div class="content--elements">
        <img class="img-fluid" src="@/assets/img/icon-note.png" alt="icon note" title="icon note"/>
        <p>20 frases</p>
      </div>
      <div class="content--elements">
        <img class="img-fluid" src="@/assets/img/icon-text.png" alt="icon text" title="icon text"/>
        <p>20 textos</p>
      </div>
      <div class="content--elements">
        <img class="img-fluid" src="@/assets/img/icon-fire.png" alt="icon fire" title="icon fire"/>
        <p>20 desafios</p>
      </div>
      <div class="content--elements">
        <img class="img-fluid" src="@/assets/img/icon-bonus.png" alt="icon bonus" title="icon bonus"/>
        <p>20 bônus</p>
      </div>
    </div> -->
    <div class="content-card-tasks--plans">
      <div class="content--title">
        <img class="img-fluid" src="@/assets/img/icon-plans.png" alt="icon plans" title="icon plans"/>
        <p>Plano:</p>
      </div>
      <div class="content--name">
        <p>{{ task.plan_name }}</p>
      </div>
    </div>
  </a>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: ['task'],
  methods: {
    ...mapActions('Tasks', ['setCurrentTask']),
    routerPage(task) {
      this.setCurrentTask({
        name: task.name,
        id: task.id
      });
      this.$router.push({ name: 'MenuTasks' });
    },
  }
}
</script>

<style lang="scss" scoped>
.content-card-tasks {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  border-radius: 10px;
  padding: 20px 15px 10px 15px;
  margin-bottom: 30px;
  min-height: 267px;
  transition: 500ms;
  &:hover,&:focus {
    cursor: pointer;
    opacity: 0.8;
  }
  &--description {
    padding-bottom: 10px;
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--black);
      text-align: center;
      margin-bottom: 0px;
      @media (min-width: 577px){
        height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 16px;
      font-family: 'Font Light';
      color: var(--black);
      text-align: center;
      margin-bottom: 0;
      @media (min-width: 577px){
        height: 120px;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  &--details {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 0px;
    max-width: 250px;
    margin: 0 auto;
    .content--elements {
      width: 50%;
      padding: 5px 0px;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        font-family: 'Font Semibold';
        color: var(--black);
        width: 80px;
        text-align: left;
        margin-bottom: 0;
      }
    }
  }
  &--plans {
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid rgba(0,0,0,0.05);
    .content--title {
      display: flex;
      align-items: center;
      margin-right: 5px;
      img {
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        font-family: 'Font Semibold';
        color: var(--black);
        margin-bottom: 0;
      }
    }
    .content--name {
      p {
        font-size: 14px;
        font-family: 'Font Light';
        color: var(--black);
        margin-bottom: 0;
      }
    }
  }
}
</style>
